import type { ReactElement } from "react";

import type { AdminSearchParams } from "../types";

import { AdminFallbackPanel } from "./AdminFallbackPanel";
import { AttributesPanel } from "./AttributesPanel";
import { CategoriesPanel } from "./CategoriesPanel";
import { TagsPanel } from "./TagsPanel";
import { UsersPanel } from "./UsersPanel";
import {
  CoreSignalConfigurationPanel,
  CoreSignalCompaniesPanel,
  CoreSignalDashboardPanel,
} from "./core-signal";
import { JobPostingsPanel } from "./job-postings";

export type AdminPanelKey = AdminSearchParams["panel"];
export type AdminPanelRenderer = () => ReactElement;

export interface AdminPanelConfig {
  title: string;
  component: AdminPanelRenderer;
}

export const adminPanelConfig: Record<AdminPanelKey, AdminPanelConfig> = {
  users: {
    title: "Users",
    component: UsersPanel,
  },
  categories: {
    title: "Categories",
    component: CategoriesPanel,
  },
  attributes: {
    title: "Attributes",
    component: AttributesPanel,
  },
  tags: {
    title: "Tags",
    component: TagsPanel,
  },
  "core-signal-dashboard": {
    title: "Core Signal Dashboard",
    component: CoreSignalDashboardPanel,
  },
  "core-signal-companies": {
    title: "Core Signal Companies",
    component: CoreSignalCompaniesPanel,
  },
  "core-signal-configuration": {
    title: "Core Signal Configuration",
    component: CoreSignalConfigurationPanel,
  },
  "job-postings": {
    title: "Job Postings",
    component: JobPostingsPanel,
  },
};

export const adminPanelRegistry: Record<AdminPanelKey, AdminPanelRenderer> =
  Object.fromEntries(
    Object.entries(adminPanelConfig).map(([key, config]) => [
      key,
      config.component,
    ])
  ) as Record<AdminPanelKey, AdminPanelRenderer>;

export { AdminFallbackPanel };
